import BannerWithSlot from './BannerWithSlot.vue';

export { BannerWithSlot };
export default BannerWithSlot;
